// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';
import { downloadArrayBufferAsXLS } from '../../../../../services/helpers';

export const pickupDashboardActions = {
  SET_PICKUP_DASHBOARD_DATE_RANGE: 'SET_PICKUP_DASHBOARD_DATE_RANGE',
  GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
  DELETE_PICKUP: 'DELETE_PICKUP',
  GET_PICKUP_DELETE_REASONS: 'GET_PICKUP_DELETE_REASONS',
  GET_REPORTING_CLUSTERS: 'GET_REPORTING_CLUSTERS',
  FILTER_DASHBOARD_DATA: 'FILTER_PICKUP_DASHBOARD_DATA',
  GET_REPORTING_LOCATIONS: 'GET_REPORTING_LOCATIONS',
  GET_PICKUP_CNS_DATA: 'GET_PICKUP_CNS_DATA',
  TOGGLE_NEW_CLIENT_FILTER: 'TOGGLE_NEW_CLIENT_FILTER'
};

export const getDashboardDataAction = (load: Object) => ({
  type: pickupDashboardActions.GET_DASHBOARD_DATA,
  payload: load
});

export const deletePickupAction = (load: Object) => ({
  type: pickupDashboardActions.DELETE_PICKUP,
  payload: load
});

export const getPickupDeleteReasonsAction = (load: Object) => ({
  type: pickupDashboardActions.GET_PICKUP_DELETE_REASONS,
  payload: load
});

export const toggleNewClientFilter = () => ({
  type: pickupDashboardActions.TOGGLE_NEW_CLIENT_FILTER
});

export const filterDashboardData = (load: Object) => ({
  type: pickupDashboardActions.FILTER_DASHBOARD_DATA,
  payload: load
});

export const getReportingLocationsAction = (load: Object) => ({
  type: pickupDashboardActions.GET_REPORTING_LOCATIONS,
  payload: load
});

export const getReportingClustersAction = (load: Object) => ({
  type: pickupDashboardActions.GET_REPORTING_CLUSTERS,
  payload: load
});

const downloadFileName = 'MIS_PICKUP.xlsx';
const downloadFileNamePickupCns = 'PICKUP_CNs.xlsx';

export const getDashboardData = obj => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'pickupDashboardLiteV2',
    method: 'GET',
    replaceParamsArr: [
      { key: 'clientId', val: obj.clientId },
      { key: 'start', val: obj.startDate },
      { key: 'end', val: obj.endDate },
      { key: 'status', val: obj.status },
      { key: 'locationId', val: obj.locationId },
      { key: 'isParentPRQ', val: obj.isParentPRQ },
      { key: 'isChildPRQ', val: obj.isChildPRQ }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload,
            dashboardDataFiltered: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getDashboardDataAction ', res);
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: [],
            dashboardDataFiltered: [],
            error: res.errorMessage || 'Could not get pickups'
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getDashboardDataAction ', res);
      dispatch(
        getDashboardDataAction({
          isLoading: false,
          isLoaded: true,
          dashboardData: [],
          dashboardDataFiltered: [],
          error: res.errorMessage || 'Could not get pickups'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getDashboardDataAction ', res);
      dispatch(
        getDashboardDataAction({
          isLoading: false,
          isLoaded: true,
          dashboardData: [],
          dashboardDataFiltered: [],
          error: 'Could not get pickups'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const deletePickup = obj => (dispatch: Function) => {
  dispatch(
    deletePickupAction({
      deletePickupInitiated: true,
      deletePickupDone: false,
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'deletepickup',
    method: 'PUT',
    data: obj,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          deletePickupAction({
            deletePickupInitiated: false,
            deletePickupDone: true,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to deletePickupAction ', res);
        dispatch(
          deletePickupAction({
            deletePickupInitiated: false,
            deletePickupDone: true,
            error: res.errorMessage || 'Could not delete pickup'
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to deletePickupAction ', res);
      dispatch(
        deletePickupAction({
          deletePickupInitiated: false,
          deletePickupDone: true,
          error: res.errorMessage || 'Could not delete pickup'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while deletePickupAction ', res);
      dispatch(
        deletePickupAction({
          deletePickupInitiated: false,
          deletePickupDone: true,
          error: 'Could not delete pickup'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getPickupDeleteReasons = obj => (dispatch: Function) => {
  dispatch(
    getPickupDeleteReasonsAction({
      pickupDeleteReasons: []
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'pickupfailurereasons',
    replaceParamsArr: [
      { key: 'userType', val: (obj && obj.user) || 'ZOOM_USER' }
    ],
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getPickupDeleteReasonsAction({
            pickupDeleteReasons: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getPickupDeleteReasons ', res);
        dispatch(
          getPickupDeleteReasonsAction({
            pickupDeleteReasons: []
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getPickupDeleteReasonsAction({
          pickupDeleteReasons: [],
          pickupdeleteReasonError: res && res.errorMessage
        })
      );
    },
    catchCb: res => {
      dispatch(
        getPickupDeleteReasonsAction({
          pickupDeleteReasons: [],
          pickupdeleteReasonError: res
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getReportingLocations = (obj: Object) => (dispatch: Function) => {
  dispatch(
    getReportingLocationsAction({
      locationList: []
    })
  );
  const { clusterCode, locationId } = obj;
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'reportinglocations',
    replaceParamsArr: [
      { key: 'locationId', val: locationId },
      { key: 'clusterCode', val: clusterCode }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getReportingLocationsAction({
            locationList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getReportingLocationsAction({
            locationList: []
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getReportingLocationsAction({
          locationList: [],
          locationfetchError: res && res.errorMessage
        })
      );
    },
    catchCb: ex => {
      dispatch(
        getReportingLocationsAction({
          locationList: [],
          locationfetchError: ex
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

/**
 * Get all the reporting clusters for the headquarter user
 * @returns {Object[]}
 */
export const getReportingClusters = () => (dispatch: Function) => {
  dispatch(
    getReportingClustersAction({
      clusterList: []
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'reportingclusters',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getReportingClustersAction({
            clusterList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getReportingClustersAction({
            clusterList: []
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getReportingClustersAction({
          clusterList: [],
          clusterfetchError: res && res.errorMessage
        })
      );
    },
    catchCb: ex => {
      dispatch(
        getReportingClustersAction({
          clusterList: [],
          clusterfetchError: ex
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const downloadData = obj => {
  let contentType;
  let apiEndPoint;
  let responseType;
  const replaceParamArr = [
    { key: 'start', val: obj.start },
    { key: 'end', val: obj.end },
    { key: 'clientId', val: obj.clientId },
    { key: 'status', val: obj.status },
    { key: 'locationId', val: obj.locationId }
  ];
  if (obj.option === 'email') {
    replaceParamArr.push({
      key: 'email',
      val: obj.email
    });
    contentType = null;
    apiEndPoint = 'sendEmailForMis';
  } else {
    contentType = 'application/xml';
    apiEndPoint = 'misDownloadExcel';
    responseType = 'arraybuffer';
  }
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint,
    method: 'GET',
    replaceParamsArr: replaceParamArr,
    contentType,
    responseType,
    successCb: res => {
      // eslint-disable-next-line no-console
      if (obj.option === 'email') {
        toastr.success('Success', 'Email sent successfully');
      } else {
        const reportName = downloadFileName;
        downloadArrayBufferAsXLS(res, reportName);
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getDashboardDataAction ', res);
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getDashboardDataAction ', res);
    }
  };
  return makeApiCall(requestObj);
};

export const downloadPickupCnsData = obj => {
  let contentType;
  let apiEndPoint;
  let responseType;
  const replaceParamArr = [{ key: 'pickupId', val: obj.id }];
  contentType = 'application/xml';
  apiEndPoint = 'pickupCnsDownload';
  responseType = 'arraybuffer';
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint,
    method: 'GET',
    replaceParamsArr: replaceParamArr,
    contentType,
    responseType,
    successCb: res => {
      // eslint-disable-next-line no-console
      downloadArrayBufferAsXLS(res, downloadFileNamePickupCns);
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getDashboardDataAction ', res);
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getDashboardDataAction ', res);
    }
  };
  return makeApiCall(requestObj);
};
